import React from 'react';
import { useSelector } from 'react-redux';
import * as call from '../../../../call';
import { components as Core } from '../../../../core';
import ParticipantsGridItemAvatar from '../../Participants/ParticipantsGrid/ParticipantsGridItem/ParticipantsGridItemAvatar';
export const ParticipantPlaceholder = ({ participant, }) => {
    const noVideoMessage = useSelector((state) => call.selectors.getNoVideoMessage(state, participant));
    return (<>
      <div className="ml-main-view__avatar">
        <ParticipantsGridItemAvatar name={participant.name} avatar={participant.avatar} size="large"/>
      </div>

      {noVideoMessage && (<div className="ml-main-view__message">
          <Core.RawHTML>{noVideoMessage}</Core.RawHTML>
        </div>)}
    </>);
};
